/**
 * 多平台 API：LST 与镜权「平台18」共用 /nft-web 路径；无忧（升清）为独立域名与鉴权头，见 `src/api/wuyou.js`。
 */
export const STORAGE_KEY = "lst_api_platform";
export const PLATFORM_LST = "lst";
export const PLATFORM_JQ18 = "jq18";
/** 无忧（升清 m 站 / api.shengqingqy.cn），鉴权与路径风格与 LST、镜权不同 */
export const PLATFORM_WUYOU = "wuyou";
const DEFAULT_LST_API = typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_LST_API_BASE
    ? import.meta.env.VITE_LST_API_BASE
    : "https://yst-api-public.zjcaee.com";
const PRESETS = {
    [PLATFORM_LST]: {
        id: PLATFORM_LST,
        label: "LST（乐数通）",
        shortLabel: "LST",
        apiBase: String(DEFAULT_LST_API).replace(/\/$/, ""),
        ystInfoOrigin: "https://yst-info.zjcaee.com",
        ystHtmlReferer: "https://yst-h5.zjcaee.com/",
        devProxyPrefix: "/yst-info"
    },
    [PLATFORM_JQ18]: {
        id: PLATFORM_JQ18,
        label: "平台18（镜权）",
        shortLabel: "平台18",
        apiBase: "https://api-mgw.jingquan.art",
        ystInfoOrigin: "https://info.jingquan.art",
        ystHtmlReferer: "https://h5.jingquan.art/",
        devProxyPrefix: "/jq-info"
    },
    [PLATFORM_WUYOU]: {
        id: PLATFORM_WUYOU,
        label: "无忧（升清）",
        shortLabel: "无忧",
        apiBase: "https://api.shengqingqy.cn",
        ystInfoOrigin: "https://m.shengqingqy.cn",
        ystHtmlReferer: "https://m.shengqingqy.cn/",
        devProxyPrefix: "/wuyou-api"
    }
};
/** 未选择过时默认镜权（平台18）；已写入 `lst_api_platform` 的仍按存储值。 */
export function getStoredPlatformId() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v && PRESETS[v])
            return v;
    }
    catch (e) {
    }
    return PLATFORM_JQ18;
}
/** `/nft-web/v1.2/nft/user/login` 密码字段：先拼接此前缀再 MD5；LST 为乐数通 `YST`，镜权为 `18art`（与官方 H5 一致）。 */
export function getLoginPasswordMd5Prefix() {
    const id = getStoredPlatformId();
    if (id === PLATFORM_JQ18)
        return "18art";
    if (id === PLATFORM_WUYOU)
        return "WUYOU";
    return "YST";
}
export function setStoredPlatformId(id) {
    if (!PRESETS[id])
        throw new Error("unknown platform");
    localStorage.setItem(STORAGE_KEY, id);
    try {
        window.dispatchEvent(new CustomEvent("api-platform-change", { detail: { id } }));
    }
    catch (e) {
    }
}
export function getPlatformPreset(id = getStoredPlatformId()) {
    return PRESETS[id] || PRESETS[PLATFORM_JQ18];
}
export function getApiBase() {
    const id = getStoredPlatformId();
    if (id === PLATFORM_WUYOU)
        return getPlatformPreset(PLATFORM_JQ18).apiBase.replace(/\/$/, "");
    return getPlatformPreset(id).apiBase.replace(/\/$/, "");
}
/** 仅无忧官方 API（/product、/market 等）；勿与 `/nft-web` 混用。开发环境走 Vite `/wuyou-api` 代理。 */
export function getWuyouApiBase() {
    try {
        if (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.DEV)
            return "/wuyou-api";
    }
    catch (e) {
    }
    return "https://api.shengqingqy.cn";
}
export function getYstInfoOrigin() {
    return getPlatformPreset().ystInfoOrigin.replace(/\/$/, "");
}
export function getYstHtmlReferer() {
    return getPlatformPreset().ystHtmlReferer;
}
export function getYstDevProxyPrefix() {
    return getPlatformPreset().devProxyPrefix || "";
}
/** 与 ystHtmlReferer 同站的 H5 根域名，用于资产流转页等（如 /item/log） */
export function getH5WebOrigin() {
    const ref = getPlatformPreset().ystHtmlReferer || "https://yst-h5.zjcaee.com/";
    try {
        return new URL(ref).origin;
    }
    catch {
        return "https://yst-h5.zjcaee.com";
    }
}
export const PLATFORM_OPTIONS = [PRESETS[PLATFORM_LST], PRESETS[PLATFORM_JQ18], PRESETS[PLATFORM_WUYOU]];
